import { useState } from 'react'
import { ArrowLeft, ChevronDown, FilePlus2, Sparkles } from 'lucide-react'
import { CARD_COLUMNS } from '../data'
import { columnMeta, projectProgress, projectWords } from '../lib/utils'
import { MiniCover } from './Shared'

export default function Binder({ project, selectedCardId, onBack, onPickCard, onAddCard, onOpenFinish, mobileOpen = false }) {
  const [closed, setClosed] = useState(() => new Set())
  const groups = []
  project.cards.forEach((card) => {
    const act = card.act || '未分幕'
    let group = groups.find((item) => item.act === act)
    if (!group) {
      group = { act, cards: [] }
      groups.push(group)
    }
    group.cards.push(card)
  })
  const progress = projectProgress(project)
  const words = projectWords(project)

  function toggle(act) {
    setClosed((current) => {
      const next = new Set(current)
      if (next.has(act)) next.delete(act)
      else next.add(act)
      return next
    })
  }

  return (
    <aside className={'binder' + (mobileOpen ? ' is-mobile-open' : '')}>
      <div className="binder-top">
        <button className="back-link" onClick={onBack}>
          <ArrowLeft size={15} /> 返回书架
        </button>
        <div className="binder-project">
          <MiniCover project={project} size={43} />
          <div className="binder-project__text">
            <h2>{project.title}</h2>
            <p>{project.type} · 第 1 稿</p>
          </div>
        </div>
        <div className="binder-progress">
          <div className="binder-progress__line"><span style={{ width: progress + '%' }} /></div>
          <div className="binder-progress__meta">
            <span>{words.toLocaleString('zh-CN')} 字</span>
            <span>{progress}% 成形</span>
          </div>
        </div>
      </div>

      <div className="binder-scroll">
        <div className="binder-label">
          <span>手稿大纲</span>
          <span>{String(project.cards.length).padStart(2, '0')}</span>
        </div>
        <div className="binder-groups">
          {groups.map((group) => {
            const isClosed = closed.has(group.act)
            return (
              <div className="binder-group" key={group.act}>
                <button className="binder-group__head" onClick={() => toggle(group.act)}>
                  <ChevronDown size={13} className={isClosed ? 'chevron closed' : 'chevron'} />
                  <span>{group.act}</span>
                  <em>{group.cards.length}</em>
                </button>
                {!isClosed ? (
                  <div className="binder-cards">
                    {group.cards.map((card) => {
                      const index = project.cards.findIndex((item) => item.id === card.id)
                      const meta = columnMeta(card.column)
                      return (
                        <button
                          key={card.id}
                          className={'binder-card ' + (card.id === selectedCardId ? 'is-active' : '')}
                          onClick={() => onPickCard(card.id)}
                        >
                          <span className="binder-card__index">{String(index + 1).padStart(2, '0')}</span>
                          <span className="binder-card__title">{card.title}</span>
                          <span className="binder-card__dot" style={{ background: meta.color }} title={meta.label} />
                        </button>
                      )
                    })}
                  </div>
                ) : null}
              </div>
            )
          })}
        </div>
        <button className="binder-add" onClick={() => onAddCard('inspiration')}>
          <FilePlus2 size={15} /> 添加一张卡片
        </button>
      </div>

      <div className="binder-foot">
        <div className="binder-legend">
          {CARD_COLUMNS.map((column) => (
            <span key={column.id}><i style={{ background: column.color }} />{column.label}</span>
          ))}
        </div>
        <button className="binder-finish" onClick={onOpenFinish}>
          <span><Sparkles size={15} /> 让 AI 帮我收束</span>
          <em>整合 · 校对 · 定稿</em>
        </button>
      </div>
    </aside>
  )
}
